module.exports = __webpack_public_path__ + "static/img/bannerNews.20ff2ff8.png";